import React, {useContext, useEffect, useState} from 'react'
import {useNavigate, useLocation} from "react-router-dom";
import {useSelector, useDispatch} from 'react-redux'
import {toggleMenu} from '../../../store/actions/MenuAction'
import Logout from '../../common/Logout';
import SessionTimeout from "../../common/SessionTimeout";
import {ThemeContext} from "../../../styles/ThemeContext";

function Header() {
    const userData = useSelector(state => state.userCredentials)
    const [logout, showLogout] = useState(false)
    const [backBtn, showBackBtn] = useState(true)
    const navigate = useNavigate();
    const location = useLocation()
    const {theme} = useContext(ThemeContext);
    useEffect(() => {
        let uri = location.pathname.replace('/', '')
        if (uri === '' || uri === 'verify') {
            showBackBtn(false)
        }

    }, []);
    const dispatch = useDispatch();

    const LogoutAction = () => {
        showLogout(true);
    }

    function toggleBar() {
        dispatch(toggleMenu('show'))
    }

    const goPreviousPage = () => {
        navigate(-1);
    }
    return (

        <>
            <SessionTimeout/>
            <header className="header"
                    style={{backgroundImage: `url(${require(`../../../assets/${theme.images.appHeader}`)})`}}>
                <Logout logout={logout} showLogout={showLogout}/>
                <div className="header_portal_name">

                    {backBtn ?
                        <button className="header_portal_menu" onClick={goPreviousPage}>
                            <svg width="25" height="25" id="icon-menu" viewBox="0 0 24 24">
                                <path fill="#fff"
                                      d="M21 11.016v1.969h-14.156l3.563 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.563 3.609h14.156z"></path>
                            </svg>
                        </button>

                        :
                        <button className="header_portal_menu" onClick={toggleBar}>
                            <svg width="25" height="25" id="icon-menu" viewBox="0 0 24 24">
                                <path fill="#fff"
                                      d="M3 12.984v-1.969h18v1.969h-18zM3 6h18v2.016h-18v-2.016zM3 18v-2.016h12v2.016h-12z"></path>
                            </svg>
                        </button>


                    }

                    <h3 className="header_portal_name_heading">Inua Mkulima Subsidy Program</h3>
                </div>
                <div className="header_logout">
                    {userData.username !== undefined ?
                        <>
                            <div className="header_logout_text">
                                Logged In As:
                                <span>{userData.username}</span>
                            </div>

                            <button className="header_logout_btn" onClick={LogoutAction}>
                                <svg id="icon-logout" width="25" height="25" viewBox="0 0 24 24">
                                    <path
                                        d="M3.984 5.016v13.969h8.016v2.016h-8.016q-0.797 0-1.383-0.609t-0.586-1.406v-13.969q0-0.797 0.586-1.406t1.383-0.609h8.016v2.016h-8.016zM17.016 6.984l4.969 5.016-4.969 5.016-1.406-1.453 2.578-2.578h-10.172v-1.969h10.172l-2.578-2.625z"></path>
                                </svg>
                                Logout
                            </button>

                        </>
                        :
                        ""
                    }
                </div>
            </header>
        </>
    );
}

export default Header;
